import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import QuestionField from './QuestionField';

const { FiChevronDown, FiChevronRight } = FiIcons;

const QuestionnaireSection = ({ index, section, isOpen, onToggle, answers, onChange }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between"
      >
        <div>
          <h2 className="text-lg font-semibold text-gray-900">{index + 1}. {section.title}</h2>
          <p className="text-sm text-gray-500">{section.questions.length} fields</p>
        </div>
        <SafeIcon icon={isOpen ? FiChevronDown : FiChevronRight} className="text-gray-400" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-gray-100"
          >
            <div className="p-6 space-y-5">
              {section.questions.map((q) => (
                <QuestionField 
                  key={q.id} 
                  question={q} 
                  value={answers[q.id]} 
                  onChange={(val) => onChange(q.id, val)} 
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default QuestionnaireSection;